<template>
  <div class="devicesPower-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span v-if="$route.query.id">编辑</span>
        <span v-else>新增</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'devicesPower' })"
        >
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="save">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="100px"
          @submit.native.prevent
          :model="formData"
          ref="ruleForm"
          label-position="top"
          :rules="rules"
        >
          <el-form-item label="标题" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
          <el-form-item label="休眠时耗电" prop="sleep">
            <el-input v-model="formData.sleep"></el-input>
          </el-form-item>
          <el-form-item label="工作时耗电" prop="working">
            <el-input v-model="formData.working"></el-input>
          </el-form-item>
          <el-form-item label="型号(多种型号用\隔开)" prop="model">
            <el-input v-model="formData.model"></el-input>
          </el-form-item>
          <el-form-item label="设备型号组" prop="modelGroups">
            <el-checkbox-group v-model="formData.modelGroups">
              <el-checkbox
                v-for="item in modelData"
                :key="item._id"
                :label="item._id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { uploadOss } from "@/utils/aliyun";
export default {
  data() {
    return {
      formData: {
        model: "",
        modelGroups: [],
        title: "",
        sleep: "",
        working: ""
      },
      params: {},
      modelData: [],
      rules: {
        // pic_address: [
        //   { required: true, message: "请选择广告封面", trigger: "change" }
        // ]
      }
    };
  },
  methods: {
    getPowerInfoDetails() {
      this.$http.getPowerInfoDetails(this.$route.query.id).then(res => {
        res.data.model = res.data.model.join("\\");
        this.formData = Object.assign(this.formData, res.data);
      });
    },

    getModelGroups() {
      this.$http.getModelGroups().then(res => {
        this.modelData = res.data.results;
      });
    },

    save() {
      this.params = Object.assign({}, this.formData);
      this.params.model = this.params.model.split("\\");
      if (this.$route.query.id) {
        this.edit();
      } else {
        this.create();
      }
    },

    create() {
      this.$http.createPowerInfo(this.params).then(res => {
        this.elMsg("创建成功", "success");
        this.$router.push({ name: "devicesPower" });
      });
    },

    edit() {
      this.$http
        .updatePowerInfo(this.$route.query.id, this.params)
        .then(res => {
          this.elMsg("编辑成功", "success");
          this.$router.push({ name: "devicesPower" });
        });
    }
  },
  mounted() {
    this.getModelGroups();
    if (this.$route.query.id) {
      this.getPowerInfoDetails();
    }
  }
};
</script>

<style lang="scss">
.devicesPower-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
    }
    .pic {
      .pic-item {
        /* position: relative; */
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .global-button-style {
        width: 80px;
        height: 30px;
      }
      .devicesPower-edit-cover {
        position: relative;
        width: 200px;
        height: 300px;
        overflow: hidden;
        margin: 10px 0;
        border: 2px dashed #ccc;
        border-radius: 10px;
        &:hover {
          border-color: #bb745c;
        }
        > img {
          width: 100%;
          height: 100%;
        }
        > .devicesPower-edit-cover-icon {
          font-weight: bold;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #bb745c;
        }
        > .devicesPower-edit-upload {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          transition: all 0.2s;
          &:hover {
            transition: all 0.2s;
            background: rgba($color: #000000, $alpha: 0.4);
            .devicesPower-edit-upload-btn {
              display: block;
            }
          }
          .devicesPower-edit-upload-btn {
            width: 100%;
            height: 100%;
            display: none;
            cursor: pointer;
            color: #fff;
            font-weight: bold;
            position: absolute;
            text-align: center;
            line-height: 300px;
            > .el-upload--text {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .add-img {
        width: 70px;
        height: 40px;
        font-size: 22px;
        line-height: 43px;
        color: #fff;
        cursor: pointer;
        background-color: #bb745c;
      }
    }
  }
}
</style>
